<template>
  <v-app>
    <app-toolbar />
    <main id="view">
      <router-view></router-view>
    </main>
    <bottomNav class="bottomNav"/>
  </v-app>
</template>

<script>
  const BottomNav = () => import('./components/Shared/BottomNav');
  export default {
    data () {
      return {
      };
    },
    created () {
      mixpanel.track('Open app');
      gtag('event', 'open_app', {event_category: 'action', event_label: 'Open app'});
      let isUploading = this.$store.getters.isUploading;
      if (window.navigator.onLine) {
        this.$store.commit('setIsOnline', true);
        if (!isUploading) {
          this.$store.dispatch('uploadStoreEvents');
        }
      } else {
        this.$store.commit('setIsOnline', false);
      }
      addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    components: {
      'bottomNav': BottomNav
    },
    methods: {
      handleResize () {
        this.$store.commit('setWidth', window.innerWidth);
        this.$store.commit('setHeight', window.innerHeight);
      }
    }
  };
</script>

<style lang="stylus">
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// App.vue?3f25022a